import React, { useState } from "react";
import clsx from "clsx";
import { mergeStyleSets } from "office-ui-fabric-react";
import { Nomination, TruckNomination } from "../../../models";
import { MODALITY } from "../../../models/WorkPacket";
import { useHistory } from "react-router-dom";

interface IProps {
  nomination: TruckNomination;
  selTransferType: string;
}

const classes = mergeStyleSets({
  container: { flex: "1 1 auto", overflowY: "auto", height: "auto" }
});

export const NominationDetailsPane: React.FC<IProps> = (props) => {
  let result = <></>;
  const { nomination, selTransferType } = props;
  const history = useHistory();
  const currentModality = () => {
    if (history.location.pathname.indexOf("truck") >= 0) {
      return "TRUCK";
    } else if (history.location.pathname.indexOf("rail") >= 0) {
      return "RAIL";
    }
  };
  const [modality, setModality] = useState<MODALITY>(
    history.location.pathname.indexOf("truck") >= 0
      ? "TRUCK"
      : history.location.pathname.indexOf("rail") >= 0
      ? "RAIL"
      : "TRUCK"
  );

  switch (selTransferType) {
    case "Loading":
      result = (
        <table className="tbl-detail">
          {modality === "TRUCK" && (
            <tbody>
              <tr>
                <td>
                  <dt>Tank</dt>
                  <dd id="lbl-nomination-tank">
                    {nomination.tank?.substring(4) || nomination.tank}&nbsp;
                  </dd>
                </td>
                <td>
                  <dt>Loading Spot</dt>
                  <dd id="lbl-loading-spot">{nomination.loadingSpot}&nbsp;</dd>
                </td>
              </tr>
              <tr>
                <td>
                  <dt>Container Type</dt>
                  <dd id="lbl-container-type">
                    {nomination.truckType === 0 && "Cargo Container"}
                    {nomination.truckType === 1 && "ISO Container"}
                    &nbsp;
                  </dd>
                </td>
                <td>
                  <dt>Surveyor</dt>
                  <dd id="lbl-nomination-surveyor">
                    {nomination.surveyor}&nbsp;
                  </dd>
                </td>
              </tr>
              <tr>
                <td>
                  <dt>Product</dt>
                  <dd id="lbl-nomination-product">
                    {nomination.product}&nbsp;
                  </dd>
                </td>
                <td>
                  <dt>Quantity</dt>
                  <dd id="lbl-nomination-quantity">
                    {nomination.quantity}&nbsp;
                  </dd>
                </td>
              </tr>
              <tr>
                <td>
                  <dt>Customer</dt>
                  <dd id="lbl-customer">{nomination.customer}&nbsp;</dd>
                </td>
                <td>
                  <dt>Customer Order #</dt>
                  <dd id="lbl-carrier">{nomination.customerOrderNo}&nbsp;</dd>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <dt>Seal Numbers Added</dt>
                  <dd id="lbl-nomination-sample-tags">
                    {nomination.sealsInstalled}&nbsp;
                  </dd>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <dt>Seal Numbers Removed</dt>
                  <dd id="lbl-nomination-sample-tags">
                    {nomination.sealsRemoved}&nbsp;
                  </dd>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <dt>Sample Tags</dt>
                  <dd id="lbl-nomination-sample-tags">
                    {nomination.sampleTags}&nbsp;
                  </dd>
                </td>
              </tr>
            </tbody>
          )}
          {modality === "RAIL" && (
            <tbody>
              <tr>
                <td>
                  <dt>Tank</dt>
                  <dd id="lbl-nomination-tank">
                    {nomination.tank?.substring(4) || nomination.tank}&nbsp;
                  </dd>
                </td>
                <td>
                  <dt>Rail Car #</dt>
                  <dd id="lbl-loading-spot">{nomination.railcars}&nbsp;</dd>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <dt>Product</dt>
                  <dd id="lbl-nomination-product">
                    {nomination.product}&nbsp;
                  </dd>
                </td>
              </tr>
              <tr>
                <td>
                  <dt>Surveyor</dt>
                  <dd id="lbl-nomination-surveyor">
                    {nomination.surveyor}&nbsp;
                  </dd>
                </td>
                <td>
                  <dt>Loading Rack</dt>
                  <dd id="lbl-loading-spot">{nomination.loadingSpot}&nbsp;</dd>
                </td>
              </tr>
              <tr>
                <td>
                  <dt>Quantity</dt>
                  <dd id="lbl-nomination-quantity">
                    {nomination.quantity}&nbsp;
                  </dd>
                </td>
                <td>
                  <dt>Customer</dt>
                  <dd id="lbl-customer">{nomination.customer}&nbsp;</dd>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <dt>Customer Order #</dt>
                  <dd id="lbl-carrier">{nomination.customerOrderNo}&nbsp;</dd>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <dt>Seal Numbers Added</dt>
                  <dd id="lbl-nomination-sample-tags">
                    {nomination.sealsInstalled}&nbsp;
                  </dd>
                </td>
              </tr>
              <tr>
                <td colSpan={2}>
                  <dt>Seal Numbers Removed</dt>
                  <dd id="lbl-nomination-sample-tags">
                    {nomination.sealsRemoved}&nbsp;
                  </dd>
                </td>
              </tr>
            </tbody>
          )}
        </table>
      );
      break;
    case "Scada":
      result = (
        <table className="tbl-detail">
          <tbody>
            <tr>
              <td>
                <dt>Event</dt>
                <dd id="lbl-nomination-event1">&nbsp;</dd>
              </td>
              <td>
                <dt>Time</dt>
                <dd id="lbl-nomination-time1">
                  {nomination.tank?.substring(4)}&nbsp;
                </dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Event</dt>
                <dd id="lbl-nomination-event2">&nbsp;</dd>
              </td>
              <td>
                <dt>Time</dt>
                <dd id="lbl-nomination-time2">
                  {nomination.tank?.substring(4)}&nbsp;
                </dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Event</dt>
                <dd id="lbl-nomination-event3">&nbsp;</dd>
              </td>
              <td>
                <dt>Time</dt>
                <dd id="lbl-nomination-time3">
                  {nomination.tank?.substring(4)}&nbsp;
                </dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Event</dt>
                <dd id="lbl-nomination-event4">&nbsp;</dd>
              </td>
              <td>
                <dt>Time</dt>
                <dd id="lbl-nomination-time4">
                  {nomination.tank?.substring(4)}&nbsp;
                </dd>
              </td>
            </tr>
          </tbody>
        </table>
      );
      break;
    case "Special":
      result = (
        <table className="tbl-detail">
          <tbody>
            <tr>
              <td colSpan={2}>
                <dt>Special Instructions</dt>
                <dd
                  id="lbl-nomination-special-instruction"
                  dangerouslySetInnerHTML={{
                    __html: nomination.specialInstructions
                  }}
                ></dd>
              </td>
            </tr>
          </tbody>
        </table>
      );
      break;
  }

  return (
    <div className={clsx(classes.container, "custom-scroll")}>
      <div>{result}</div>
    </div>
  );
};
